"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitResult = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const Colors_1 = require("../../../../Colors");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const SubmitResultStyled = styled_components_1.default.div `
	${({ $isHome, $isMobile, $isTablet }) => $isMobile
    ? `
				.submit-wrap {
					border-radius: 10px;
					display: flex;
					flex-direction: row;
					gap: 12px;
					align-items: flex-start;
					justify-content: flex-start;
					align-self: stretch;
					flex: 1;
					position: relative;
				}

				.submit-item {
					background: #feffff;
					border-radius: 8px;
					border-style: solid;
					border-color: var(--tur, #3ab2bf);
					border-width: 1px;
					padding: 20px;
					display: flex;
					flex-direction: column;
					gap: 32px;
					align-items: self-end;
					justify-content: center;
					flex: 1;
					position: relative;
				}

				.submit-label {
					display: flex;
					flex-direction: column;
					gap: 0px;
					align-items: flex-start;
					justify-content: flex-start;
					align-self: stretch;
					flex-shrink: 0;
					min-width: 102px;
					position: relative;
				}

				.label {
					color: var(--color-grey, #666666);
					text-align: center;
					font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
					font-size: var(--b3-font-size, 16px);
					line-height: var(--b3-line-height, 32px);
					letter-spacing: var(--b3-letter-spacing, -0.02em);
					font-weight: var(--b3-font-weight, 400);
					position: relative;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
				}

				.value {
					color: var(--tur-d, #479da6);
					text-align: center;
					font-family: var(--h2-font-family, "Noto Sans KR", sans-serif);
					font-size: var(--h2-font-size, 32px);
					line-height: var(--h2-line-height, 46px);
					letter-spacing: var(--h2-letter-spacing, -0.02em);
					font-weight: var(--h2-font-weight, 700);
					position: relative;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
				  }
			`
    : `
				display: flex;
				flex-direction: column;
				gap: 12px;
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				flex-shrink: 0;
				position: relative;
				padding-bottom: 16px;
			.submit-wrap {
				background: #feffff;
				border-radius: 8px;
				border-style: solid;
				border-color: var(--tur, #3ab2bf);
				border-width: 1px;
				padding: 20px 0;
				display: flex;
				flex-direction:  row;
				gap: 20px;
				align-items: center;
				justify-content: center;
				align-self: stretch;
				flex-shrink: 0;
				position: relative;
				flex-wrap: wrap;
				width: 80%;
				margin: 0 auto;
			}
			.divider {
				background: #d9d9d9;
				flex-shrink: 0;
				width: 1px;
				height: 24px;
				position: relative;
			}

			.submit-wrap {
				display: flex;
				flex-direction: row;
				gap: 0px;
				align-items: center;
				justify-content: center;
				position: relative;
				flex: 1;
			}

			.submit-label {
				display: flex;
				flex-direction: column;
				gap: 0px;
				align-items: center;
				justify-content: center;
				align-self: stretch;
				flex-shrink: 0;
				min-width: 102px;
				position: relative;
			}
			.submit-item {
				display: flex;
				flex-direction: column;
				gap: 0px;
				align-items: center;
				justify-content: center;
				flex: 1;
				min-width: 120px;
				position: relative;
			}
			.label {
				color: var(--color-grey, #666666);
				text-align: center;
				font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
				letter-spacing: var(--b2-letter-spacing, -0.02em);
				font-weight: var(--b2-font-weight, 400);
				position: relative;
				text- overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;

				${$isTablet
        ? (0, styled_components_1.css) `
								font-size: var(--b3-font-size, 16px);
								line-height: var(--b3-line-height, 32px);
						  `
        : (0, styled_components_1.css) `
								font-size: var(--b2-font-size, 18px);
								line-height: var(--b2-line-height, 36px);
						  `}
			}

			.value {
				color: var(--tur-d, #479da6);
				text- align: center;
				font-family: var(--h2-font-family, "Noto Sans KR", sans-serif);
				letter-spacing: var(--h2-letter-spacing, -0.02em);
				font-weight: var(--h2-font-weight, 700);
				position: relative;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;

				${$isTablet
        ? (0, styled_components_1.css) `
								font-size: var(--h4-font-size, 20px);
								line-height: var(--h4-line-height, 32px);
						  `
        : (0, styled_components_1.css) `
								font-size: var(--h2-font-size, 32px);
								line-height: var(--h2-line-height, 46px);
						  `}

			}
	`}
`;
exports.SubmitResult = react_1.default.memo(({ isSubmit, selectName, test_id, member_id, isHome = false, messageOnly = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [allGrades, setAllGrades] = (0, react_1.useState)({
        score: 0,
        correctIndex: 0,
        allIndex: 0,
        allScore: 0,
    });
    const { data: scoreData, refetch: scoreRefetch } = (0, server_1.useScoreStatus)({
        id: test_id,
        member_id,
        valid_correction: true,
    });
    (0, react_1.useEffect)(() => {
        if (!scoreData)
            return;
        // let result: Map<string, Grade> = new Map();
        let allResult = { score: 0, correctIndex: 0, allIndex: 0, allScore: 0 };
        scoreData.forEach((item) => {
            const score = item.correction === 'O' ? item.point : 0;
            const correctIndex = item.correction === 'O' ? 1 : 0;
            const allScore = item.point;
            const allIndex = 1;
            // if (result.has(item.subject)) {
            // 	const existing = result.get(item.subject)!;
            // 	result.set(item.subject, {
            // 		score: score + existing.score,
            // 		correctIndex: correctIndex + existing.correctIndex,
            // 		allScore: allScore + existing.allScore,
            // 		allIndex: existing.allIndex + allIndex,
            // 	});
            // } else {
            // 	result.set(item.subject, { score, correctIndex, allScore, allIndex });
            // }
            allResult = {
                score: allResult.score + score,
                correctIndex: allResult.correctIndex + correctIndex,
                allScore: allResult.allScore + allScore,
                allIndex: allResult.allIndex + allIndex,
            };
        });
        setAllGrades(allResult);
    }, [scoreData]);
    (0, react_1.useEffect)(() => {
        scoreRefetch();
    }, [test_id, member_id, isSubmit]);
    return (react_1.default.createElement(SubmitResultStyled, { className: "status-panel", "$isHome": isHome, "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet },
        isSubmit && (react_1.default.createElement("div", { className: "final-notification" },
            react_1.default.createElement("div", { className: "line" }),
            react_1.default.createElement("div", { className: "message" },
                react_1.default.createElement(common_1.Icon, { icon: "check-circle", size: 24, fill: Colors_1.Colors.pink }),
                react_1.default.createElement("div", { className: "div" }, t('assignment.submitCompleted'))),
            react_1.default.createElement("div", { className: "line" }))),
        !messageOnly && isDesktop && react_1.default.createElement("div", { className: "title" }, t('assignment.submitResult')),
        !messageOnly && (react_1.default.createElement("div", { className: "submit-wrap" },
            react_1.default.createElement("div", { className: "submit-item" },
                react_1.default.createElement("div", { className: "submit-label" },
                    react_1.default.createElement("div", { className: "label" }, "\uC815\uB2F5 \uC218"),
                    react_1.default.createElement("div", { className: "value" }, isSubmit ? allGrades.correctIndex : '-')),
                isMobile && react_1.default.createElement(common_1.Icon, { icon: "answerCount", size: 48 })),
            !isMobile && react_1.default.createElement("div", { className: "divider" }),
            react_1.default.createElement("div", { className: "submit-item" },
                react_1.default.createElement("div", { className: "submit-label" },
                    react_1.default.createElement("div", { className: "label" }, "\uC6D0\uC810\uC218 (\uCD1D\uC810)"),
                    react_1.default.createElement("div", { className: "value" }, isSubmit ? allGrades.score : '-')),
                isMobile && react_1.default.createElement(common_1.Icon, { icon: "totalCount", size: 48 }))))));
});
